export const EMAIL_PATTERN = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const PHONE_NUMBER_PATTERN = /^\+*[0-9]+\s?[0-9]+$/;
export const REGISTRATION_PHONE_NUMBER_PATTERN = /^[+]?\d{7,20}$/;
export const NAME_PATTERN = /^[a-zA-Z-/ äöüÖÄÜß0-9]+$/;
export const ALPHA_NUMERIC_PATTERN = /^[a-zA-Z- 0-9]+$/;
